const boardRoutes = [
  {
    path: "board",
    redirect: { path: "/board/notice" },
    meta: {
      title: "게시판",
      titleEn: "Board",
      menuCd: "CLIENT_BOARD",
    },
    children: [
      {
        path: "notice", // board/notice
        meta: {
          title: "공지사항",
          titleEn: "Notice",
          isDynamic: true,
          menuCd: "BOARD_NOTICE",
        },
        component: () => import("@/views/board/BoardNoticeIndex.vue"),
      },
      {
        path: "notice/detail", // board/notice/detail
        meta: {
          title: "공지사항 상세",
          titleEn: "Notice Detail",
          isDynamic: true,
          menuCd: "BOARD_NOTICE",
        },
        component: () => import("@/views/board/BoardNoticeDetail.vue"),
      },
      {
        path: "resources", // board/resources
        meta: {
          title: "자료실",
          titleEn: "Resources",
          isDynamic: true,
          menuCd: "BOARD_RESOURCES",
        },
        component: () => import("@/views/board/BoardResourcesIndex.vue"),
      },
      {
        path: "resources/detail", // board/resources/detail
        meta: {
          title: "자료실 상세",
          titleEn: "Resources Detail",
          isDynamic: true,
          menuCd: "BOARD_RESOURCES",
        },
        component: () => import("@/views/board/BoardResourcesDetail.vue"),
      },
      {
        path: "gallery", // board/gallery
        meta: {
          title: "갤러리",
          titleEn: "Gallery",
          isDynamic: true,
          menuCd: "BOARD_GALLERY",
        },
        component: () => import("@/views/board/BoardGalleryIndex.vue"),
      },
      {
        path: "gallery/detail", // board/gallery/detail
        meta: {
          title: "갤러리 상세",
          titleEn: "Gallery Detail",
          isDynamic: true,
          menuCd: "BOARD_GALLERY",
        },
        component: () => import("@/views/board/BoardGalleryDetail.vue"),
      },
      {
        path: "qna", // board/qna
        meta: {
          title: "Q&A",
          titleEn: "Q&A",
          isDynamic: true,
          menuCd: "BOARD_QNA",
        },
        component: () => import("@/views/board/BoardQnaIndex.vue"),
      },
      {
        path: "qna/write", // board/qna/write
        meta: {
          title: "Q&A 등록",
          titleEn: "Q&A Write",
          isDynamic: true,
          menuCd: "BOARD_QNA",
        },
        component: () => import("@/views/board/BoardQnaWrite.vue"),
      },
      {
        path: "qna/password", // board/qna/password
        meta: {
          title: "Q&A 비밀번호 입력",
          titleEn: "Q&A Password",
          isDynamic: true,
          menuCd: "BOARD_QNA",
        },
        component: () => import("@/views/board/BoardQnaPassword.vue"),
      },
      {
        path: "qna/detail", // board/qna/detail
        meta: {
          title: "Q&A 상세",
          titleEn: "Q&A Detail",
          isDynamic: true,
          menuCd: "BOARD_QNA",
        },
        component: () => import("@/views/board/BoardQnaDetail.vue"),
      },
    ],
  },
];
export default boardRoutes;
